import React, { useEffect, useState } from "react";

const CurrencyContent = () => {
    const [rates, setRates] = useState([]);
    const [loading, setLoading] = useState(true);
    const currencyMeta = {
        USD: { country: 'us', name: 'United States Dollar' },
        SGD: { country: 'sg', name: 'Singapore Dollar' },
        'SGD (100)': { country: 'sg', name: 'Singapore Dollar (100)' },
        'SGD (1000)': { country: 'sg', name: 'Singapore Dollar (1000)' },
        MYR: { country: 'my', name: 'Malaysian Ringgit' },
        HKD: { country: 'hk', name: 'Hong Kong Dollar' },
        CNY: { country: 'cn', name: 'Chinese Yuan' },
        AUD: { country: 'au', name: 'Australian Dollar' },
        EUR: { country: 'eu', name: 'Euro' },
        THB: { country: 'th', name: 'Thai Baht' },
        TWD: { country: 'tw', name: 'New Taiwan Dollar' },
        JPY: { country: 'jp', name: 'Japanese Yen' },
        GBP: { country: 'gb', name: 'Pound Sterling' },
        SAR: { country: 'sa', name: 'Saudi Riyal' },
        KRW: { country: 'kr', name: 'South Korean Won' },
        VND: { country: 'vn', name: 'Vietnamese Dong' },
        RMB: { country: 'cn', name: 'Chinese Renminbi' },
    };
    // Fetch function
    const fetchRates = () => {
        setLoading(true);
        const today = new Date().toISOString().slice(0, 10);

        fetch(`https://admin.cemaravalas.com/api/currency-rates?rate_date=${today}`)
            .then((res) => res.json())
            .then((data) => {
                setRates(data.data || []);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching rates:", err);
                setLoading(false);
            });
    };

    // Call once on mount
    useEffect(() => {
        fetchRates();
    }, []);

    return (
        <section className="latest-articles blog-contant grid">
            <div className="overlay pt-120 pb-120">
                <div className="container wow fadeInUp">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="section-header text-center">

                                <p>
                                    Kurs yang ditampilkan merupakan kurs indikatif dan dapat berubah sewaktu-waktu tanpa pemberitahuan sebelumnya.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {new Date().toLocaleDateString("en-US", {
                            weekday: "long",
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                        })}
                        {/* Reload button */}
                        <div className="mb-3">
                            <button
                                onClick={fetchRates}
                                className="cmn-btn"
                            >
                                Reload Rates
                            </button>
                        </div>

                        <br/><br/>
                        <table
                            data-toggle="table"
                            data-search="true"
                            className="table table-bordered"

                        >
                            <thead>
                            <tr>
                                {/* Merge flag + currency text under one header */}
                                <th colSpan={2} className="text-center px-4 py-2">Currencies</th>
                                <th className="text-right px-4 py-2">Buy</th>
                                <th className="text-right px-4 py-2">Sell</th>
                            </tr>

                            </thead>
                            <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="3">Loading...</td>
                                </tr>
                            ) : rates.length > 0 ? (
                                rates.map((rate, index) => {
                                    // Map currency to ISO country code
                                    const meta = currencyMeta[rate.currency];

                                    const rowClass = index % 2 === 0 ? 'bg-white' : 'bg-gray-50';
                                    return (
                                        <tr key={rate.id} className={rowClass} >
                                            {/* Column 1: Flag */}
                                            <td className="px-4 py-2">
                                                <div className="flex items-center h-full">
                                                    {meta?.country && (
                                                        <span
                                                            className={`fi fi-${meta.country}`}
                                                            style={{
                                                                width: '40px',
                                                                height: '30px',
                                                                border: '1px solid #ccc',
                                                                borderRadius: '4px',
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </td>


                                            {/* Column 2: Currency code + name */}
                                            <td className="px-4 py-2">
                                                <div className="flex flex-col leading-tight">
                                                    <span className="font-medium">{rate.currency}</span>
                                                    {meta?.name && (
                                                        <div className="text-sm text-gray-600">{meta.name}</div>
                                                    )}
                                                </div>
                                            </td>

                                            {/* Column 3: Buy */}
                                            <td className="text-right px-4 py-2">
                                                {Number(rate.buy).toLocaleString()}
                                            </td>

                                            {/* Column 4: Sell */}
                                            <td className="text-right px-4 py-2">
                                                {Number(rate.sell).toLocaleString()}
                                            </td>
                                        </tr>
                                    );



                                })


                            ) : (
                                <tr>
                                    <td colSpan="3">No rates found</td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CurrencyContent;